import React from "react";
import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description }) => {
  const fullTitle = title
    ? `${title} | Speed Shipping Agencies`
    : "Speed Shipping Agencies | Global Maritime Logistics";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
    </Helmet>
  );
};
